export default {
    order_identifier: '',
    fulfilment_method: '',
    dispatch_type: '',
    dispatcher_type: '',
    dispatcher_identifier: '',
    dispatch_request_status: '',
    dispatch_request_batch: '',
    responsible_location_type: 'store',
    responsible_location_identifier: '',
    hold_status: '',
    order_placed_from: '',
    order_placed_to: '',
    max_age_days: '',
    promised_delivery_date: '',

    sales_formula_identifier: '',
    sales_channel_identifier: '',

    carrier_method: '',
    payment_method: '',
    has_comments: '',
    is_paused: '',

    refunds: '',

    product_identifiers: [],

    customer_identifier: '',
    address_type: '',
    address_name: '',
    address_zipcode: '',
    address_city: '',
    address_email: '',
    address_country: '',
    address_fulltext: '',

    has_order_responsible_location: '',
    has_assign_error: '',

    validation_status: '',

    sort_by: 'placed_at',
    sort_dir: 'desc',

    offset: 0,
    limit: 100,
    include: [
        'sales_order_lines',
        'current_dispatch_requests_with_paused.storage_location.storage_zone',
        'current_dispatch_requests_with_paused.dispatch_request_address',
        'current_dispatch_requests_with_paused.dispatch_request_batch',
        'addresses',
        'current_sales_order_payments',
        'current_refund_requests',
        'global_sales_order_status',
    ].join(','),

    // Meta vars
    isCollapsed: false,
}
